export const SERVER_URL = process.env.REACT_APP_SERVER_URL || "http://localhost:3002";
export const BOT_ID = process.env.REACT_APP_BOT_ID || "dspace";
export const CHATBOT_URL = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ""}`;
export const REACT_HOST_URL = process.env.REACT_APP_HOST_URL || "http://localhost:3000";